import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import firebaseConfig from '../../config';

const { databaseId } = firebaseConfig;

function DeviceTrackingFactory(firebase) {
  const logDeviceSession = async ({
    sessionId,
    uid,
    deviceType,
    userAgent = null,
    screenWidth = null,
    screenHeight = null,
    hasTouch = null
  }) => {
    try {
      const deviceSessionData = {
        sessionId,
        uid,
        deviceType,
        timestamp: serverTimestamp(),
        databaseId
      };

      // Add optional fields if provided
      if (userAgent) deviceSessionData.userAgent = userAgent;
      if (screenWidth) deviceSessionData.screenWidth = screenWidth;
      if (screenHeight) deviceSessionData.screenHeight = screenHeight;
      if (hasTouch !== null) deviceSessionData.hasTouch = hasTouch;

      const deviceSessionsRef = collection(firebase.fsdb, 'deviceSessions');
      const docRef = await addDoc(deviceSessionsRef, deviceSessionData);

      return docRef.id;
    } catch (error) {
      console.error('Error logging device session:', error);
      throw error;
    }
  };

  return {
    logDeviceSession
  };
}

export default DeviceTrackingFactory;
